/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { RegionListAdmin } from './RegionListAdmin'
import {
  RegionListAdminFromJSON,
  RegionListAdminFromJSONTyped,
  RegionListAdminToJSON,
} from './RegionListAdmin'

/**
 *
 * @export
 * @interface PaginatedRegionListAdmin
 */
export interface PaginatedRegionListAdmin {
  /**
   *
   * @type {Array<RegionListAdmin>}
   * @memberof PaginatedRegionListAdmin
   */
  results: Array<RegionListAdmin>
  /**
   *
   * @type {number}
   * @memberof PaginatedRegionListAdmin
   */
  count: number
  /**
   *
   * @type {string}
   * @memberof PaginatedRegionListAdmin
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedRegionListAdmin
   */
  previous: string | null
}

/**
 * Check if a given object implements the PaginatedRegionListAdmin interface.
 */
export function instanceOfPaginatedRegionListAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'results' in value
  isInstance = isInstance && 'count' in value
  isInstance = isInstance && 'next' in value
  isInstance = isInstance && 'previous' in value

  return isInstance
}

export function PaginatedRegionListAdminFromJSON(json: any): PaginatedRegionListAdmin {
  return PaginatedRegionListAdminFromJSONTyped(json, false)
}

export function PaginatedRegionListAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedRegionListAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    results: (json['results'] as Array<any>).map(RegionListAdminFromJSON),
    count: json['count'],
    next: json['next'],
    previous: json['previous'],
  }
}

export function PaginatedRegionListAdminToJSON(value?: PaginatedRegionListAdmin | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    results: (value.results as Array<any>).map(RegionListAdminToJSON),
    count: value.count,
    next: value.next,
    previous: value.previous,
  }
}
